<main class="page background" style="--color: {{ color || '#FFFFFF' }}">

    <h1>Welcome back, {{ userFirstName }}</h1>

    <div *ngIf="enrichedProductAccess$ | async as productAccess else loading">
        <div class="ui-grid ui-grid-cols-12 ui-gap-xl custom-ui-grid-cols-auto-fit">
            <div class="ui-col-span-8">
                <global-home-product-card
                        [packageName]="productAccess.packageName"
                        [exploreProductIds]="productAccess.exporableProducts"
                        [accessProductList]="productAccess.accessibleProducts"
                        [consumerResearchUrl]="consumerResearchUrl"
                        [environment]="environment"
                >
                </global-home-product-card>
            </div>
            <div class="ui-col-span-4">
                <global-home-info-card
                        (trackInfoCardClicks)="dispatchEvent($event)"
                        [consumerResearchUrl]="consumerResearchUrl"
                        [hasConsumerResearchAccess]="productAccess.hasConsumerResearchAccess"
                        [hasSocialMediaAccess]="productAccess.hasSocialMediaAccess"
                        [hasAdministrationAccess]="productAccess.hasAdministrationAccess"
                        [environment]="environment"
                ></global-home-info-card>
                <global-home-promo-card></global-home-promo-card>
            </div>
        </div>
    </div>
    <ng-template #loading>
        <global-home-loader size="large"></global-home-loader>
    </ng-template>
</main>
